// start:ng42.barrel
import './currency-symbol.filter';
import './decoded.filter';
import './as-utc.filter.js';
// end:ng42.barrel

